import { render, staticRenderFns } from "./HTMLReader.vue?vue&type=template&id=6cb96d3a&scoped=true"
import script from "./HTMLReader.vue?vue&type=script&lang=js"
export * from "./HTMLReader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb96d3a",
  null
  
)

export default component.exports